import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';

import { TokenStorageService } from '../auth/token-storage.service';
import { AuthService } from '../auth/auth.service';
import { AppConfigService } from '../config/app-config.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const tokenStorage = inject(TokenStorageService);
  const authService  = inject(AuthService);
  const config       = inject(AppConfigService);

  const empPortalBaseUrl = config.get('empPortalBaseUrl');
  const isEmpPortal = empPortalBaseUrl && req.url.includes(empPortalBaseUrl);

  // Don't intercept apptorID token/revoke endpoints, Employee Portal auth endpoint, or other Employee Portal calls
  if (isEmpPortal || req.url.includes('/oidc/') || req.url.includes('/authenticate-employee-with-cognito-token')) {
    return next(req);
  }

  const accessToken = tokenStorage.getAccessToken();
  const authReq = accessToken
    ? req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/')) {
        return authService.refreshAccessToken().pipe(
          switchMap(newToken => {
            if (newToken) {
              const retried = req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` }
              });
              return next(retried);
            }
            return throwError(() => error);
          }),
          catchError(refreshErr => {
            authService.logout();
            return throwError(() => refreshErr);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
